//import clsx from "clsx";

/*export function Logo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 260 35"
      className={clsx("text-slate-900 dark:text-white", className)}
    >
      <path
        fill="#4788c7"
        d="M25,5v4H15V5H25 M25,3H15c-1.105,0-2,0.895-2,2v6h14V5C27,3.895,26.105,3,25,3L25,3z"
      />
      <path
        fill="#98ccfd"
        d="M1.5,35.5V11c0-1.378,1.121-2.5,2.5-2.5h32c1.379,0,2.5,1.122,2.5,2.5v24.5H1.5z"
      />
      <path
        fill="#4788c7"
        d="M36,9c1.103,0,2,0.897,2,2v24H2V11c0-1.103,0.897-2,2-2H36 M36,8H4c-1.657,0-3,1.343-3,3v25h38V11C39,9.343,37.657,8,36,8L36,8z"
      />
      <path
        fill="none"
        stroke="#4788c7"
        strokeMiterlimit="10"
        d="M38.5 14.5L1.5 14.5"
      />
      <path fill="#fff" d="M19 19H21V29H19z" />
      <path fill="#fff" d="M15 23H25V25H15z" />
      <path
        fill="#dff0fe"
        d="M32,16.5c-0.275,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.225-0.5,0.5-0.5h2c0.275,0,0.5,0.224,0.5,0.5v3c0,0.276-0.225,0.5-0.5,0.5H32z"
      />
      <path
        fill="#4788c7"
        d="M34,13v3h-2v-3H34 M34,12h-2c-0.552,0-1,0.448-1,1v3c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-3C35,12.448,34.552,12,34,12L34,12z"
      />
      <path
        fill="#dff0fe"
        d="M6,16.5c-0.275,0-0.5-0.224-0.5-0.5v-3c0-0.276,0.225-0.5,0.5-0.5h2c0.275,0,0.5,0.224,0.5,0.5v3c0,0.276-0.225,0.5-0.5,0.5H6z"
      />
      <path
        fill="#4788c7"
        d="M8,13v3H6v-3H8 M8,12H6c-0.552,0-1,0.448-1,1v3c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-3C9,12.448,8.552,12,8,12L8,12z"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="currentColor"
        d="M68.48,13.576l-3.672,0l-0.912,0l-0.6,0l0,16.824l0.6,0l0.912,0l3.672,0q3.504,0,6-2.448q2.568-2.52,2.568-6.12q0-3.408-2.568-5.856q-2.52-2.4-6-2.4z M68.48,28.888l-3.672,0l0-13.752l3.672,0q3,0,5.04,1.968q2.016,1.968,2.016,4.728q0,3-2.016,5.016q-2.04,2.04-5.04,2.04z M87.91616,21.976l1.8,0q1.824,0,3.024-1.2t1.2-3.024q0-1.608-1.2-2.88q-1.272-1.32-3.024-1.32l-7.512,0l-1.488,0l0,16.848l1.488,0l0-8.424l3.912,0l5.112,8.424l1.8,0z M82.20416,20.488l0-5.424l7.512,0q1.104,0,1.944,0.792q0.792,0.792,0.792,1.896q0,1.152-0.792,1.944q-0.84,0.792-1.944,0.792l-7.512,0z M100.29632,29.056q0-0.768-0.468-1.236t-1.236-0.468q-0.528,0-0.936,0.48t-0.408,1.224q0,0.504,0.42,0.924t0.924,0.42q0.744,0,1.224-0.408t0.48-0.936z M112.00064,30.352l1.488,0l0-10.152q0-2.016,1.536-3.552t3.552-1.536q1.968,0,3.552,1.536q1.512,1.512,1.512,3.552l0,10.152l1.536,0l0-10.152q0-2.064,1.536-3.552q1.536-1.536,3.528-1.536q2.016,0,3.552,1.536t1.536,3.552l0,10.152l1.488,0l0-10.152q0-2.736-1.92-4.656t-4.656-1.92q-1.8,0-3.384,0.984q-1.608,1.008-2.304,2.568q-0.936-1.608-2.52-2.568q-1.656-0.984-3.456-0.984q-2.712,0-4.632,1.92q-1.944,1.944-1.944,4.656l0,10.152z M142.0688,25.792q0-1.152,0.816-2.088q0.816-0.984,1.968-0.984l0.312,0l4.488,0l0-1.488l-4.488,0l-0.312,0q-1.224-0.24-2.004-1.056t-0.78-1.944q0-1.416,0.828-2.244t2.268-0.828l8.16,0l0-1.512l-8.16,0q-1.848,0-3.216,1.368q-1.368,1.32-1.368,3.216q0,1.2,0.456,2.184t1.344,1.416q-0.888,0.648-1.344,1.704t-0.456,2.256q0,1.872,1.368,3.192q1.392,1.392,3.216,1.392l8.16,0l0-1.584l-8.16,0q-1.44,0-2.268-0.816t-0.828-2.184z M160.23296,15.352l9.048,0l0-1.824l-9.048,0q-1.776,0-2.976,1.392q-1.224,1.416-1.224,3.432q0,1.824,1.224,3.168q1.2,1.368,2.976,1.368l2.4,0l2.448,0q1.08,0,1.92,0.912q0.792,0.96,0.792,2.088q0,1.344-0.78,2.184t-1.932,0.84l-9.048,0l0,1.488l9.048,0q1.8,0,3-1.248t1.2-3.264q0-1.824-1.2-3.168q-1.224-1.344-3-1.344l-2.448,0l-2.4,0q-1.104,0-1.896-0.96q-0.816-0.888-0.816-2.064q0-1.344,0.78-2.172t1.932-0.828z M185.95712,13.552l-1.512,0l0,7.68l-10.128,0l0-7.68l-1.512,0l0,16.848l1.512,0l0-7.656l10.128,0l0,7.656l1.512,0l0-16.848z M196.03328,13.504q-2.688,0-4.512,1.944q-1.8,1.92-1.8,4.68l0,10.272l1.512,0l0-7.536l9.648,0l0,7.536l1.512,0l0-10.272q0-2.76-1.8-4.68q-1.872-1.944-4.56-1.944z M200.88128,21.376l-9.648,0l0-1.248q0-2.064,1.392-3.576q1.416-1.536,3.408-1.536t3.456,1.536q1.392,1.512,1.392,3.576l0,1.248z M213.35744,21.976l1.8,0q1.824,0,3.024-1.2t1.2-3.024q0-1.608-1.2-2.88q-1.272-1.32-3.024-1.32l-7.512,0l-1.488,0l0,16.848l1.488,0l0-8.424l3.912,0l5.112,8.424l1.8,0z M207.64544,20.488l0-5.424l7.512,0q1.104,0,1.944,0.792q0.792,0.792,0.792,1.896q0,1.152-0.792,1.944q-0.84,0.792-1.944,0.792l-7.512,0z M222.9776,30.424l1.512,0l0-16.872l-1.512,0l0,16.872z"
      ></path>
    </svg>
  );
}*/

export function Logo({ className }: { className?: string }) {
  return (
    <div className={className}>
      <img src="./images/logo.png" className="ltr:mr-2 rtl:ml-2" style={{
        width: 35,
        height: 35
      }} />
      <div>
        <h1 className="text-base">الإدارة المركزية للرعاية الصحية الأولية</h1>
        <h2 className="text-base">central directorate of primary health care</h2>
      </div>
    </div>
  );
}
